(() => {
  const roots = () => document.querySelectorAll('[data-contact-float]');

  const findChatActivator = () => {
    const chatHost = document.querySelector('shopify-chat');
    if (!chatHost?.shadowRoot) return null;
    return chatHost.shadowRoot.querySelector('[part="activator"], .activator')
      || chatHost.shadowRoot.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part="activator"], .activator');
  };

  const visibleBottom = (element) => {
    if (!element) return null;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 ? rect.bottom : null;
  };

  const positionPanelOverlay = (root) => {
    const rootRect = root.getBoundingClientRect();
    const bottoms = [rootRect.bottom];
    const localizationBottom = visibleBottom(document.querySelector('.senbeder-localization-float'));
    const chatBottom = visibleBottom(findChatActivator());
    if (localizationBottom !== null) bottoms.push(localizationBottom);
    if (chatBottom !== null) bottoms.push(chatBottom);
    const overlap = Math.max(0, Math.ceil(Math.max(...bottoms) - rootRect.bottom + 8));
    root.style.setProperty('--scf-panel-overlap', `${overlap}px`);
  };

  const positionAtTopOfStack = (root) => {
    const localization = document.querySelector('.senbeder-localization-float');
    const target = localization?.getBoundingClientRect().width ? localization : findChatActivator();
    if (!target) {
      root.style.setProperty('--scf-stack-bottom', window.innerWidth <= 749 ? '194px' : '195px');
      positionPanelOverlay(root);
      return;
    }
    const rect = target.getBoundingClientRect();
    const bottom = Math.max(16, Math.round(window.innerHeight - rect.top + 8));
    root.style.setProperty('--scf-stack-bottom', `${bottom}px`);
    positionPanelOverlay(root);
  };

  const init = (root) => {
    if (root.dataset.contactFloatInitialized === 'true') return;
    root.dataset.contactFloatInitialized = 'true';

    const trigger = root.querySelector('[data-contact-float-trigger]');
    const panel = root.querySelector('[data-contact-float-panel]');
    const closeButton = root.querySelector('[data-contact-float-close]');
    const quoteTrigger = root.querySelector('[data-contact-float-quote-trigger]');
    const quotePanel = root.querySelector('[data-contact-float-quote-panel]');
    const quoteCloseButton = root.querySelector('[data-contact-float-quote-close]');
    if (!trigger || !panel || !closeButton) return;

    const contactButtons = [...root.querySelectorAll('[data-contact-person-button]')];
    const profileName = root.querySelector('[data-contact-profile-name]');
    const profileAvatar = root.querySelector('[data-contact-profile-avatar]');
    const whatsappLink = root.querySelector('[data-contact-whatsapp-link]');
    const whatsappLabel = root.querySelector('.senbeder-contact-float__channels [data-contact-whatsapp-label]');
    const emailLink = root.querySelector('[data-contact-email-link]');
    const emailLabel = root.querySelector('[data-contact-email-label]');

    const selectContact = (button) => {
      if (!button || !profileName || !profileAvatar || !whatsappLink || !whatsappLabel || !emailLink || !emailLabel) return;
      const data = button.dataset;
      if (!data.contactName || !data.contactAvatar || !data.contactWhatsappHref || !data.contactEmail) return;
      root.dataset.contactPerson = data.contactPerson;
      profileName.textContent = data.contactName;
      profileAvatar.src = data.contactAvatar;
      profileAvatar.alt = data.contactAvatarAlt || data.contactName + ' contact avatar';
      whatsappLink.href = data.contactWhatsappHref;
      whatsappLabel.textContent = data.contactWhatsappLabel || '';
      emailLink.href = 'mailto:' + data.contactEmail;
      emailLabel.textContent = data.contactEmail;
      contactButtons.forEach((contactButton) => {
        contactButton.setAttribute('aria-pressed', String(contactButton === button));
      });
    };

    contactButtons.forEach((button) => button.addEventListener('click', () => selectContact(button)));

    const fitPanel = (activePanel) => {
      if (!activePanel || activePanel.hidden) return;
      activePanel.style.top = 'auto';
      activePanel.style.bottom = '0';
      const panelTop = activePanel.getBoundingClientRect().top;
      if (panelTop < 16) {
        activePanel.style.bottom = 'auto';
        activePanel.style.top = String(16 - root.getBoundingClientRect().top) + 'px';
      }
    };

    let hideTimer;
    const isOpen = () => trigger.getAttribute('aria-expanded') === 'true';
    const isQuoteOpen = () => quoteTrigger?.getAttribute('aria-expanded') === 'true';

    const open = () => {
      window.clearTimeout(hideTimer);
      const localizationTrigger = document.querySelector('[data-localization-float-trigger][aria-expanded="true"]');
      localizationTrigger?.click();
      root.classList.remove('is-quote-open');
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      fitPanel(panel);
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('senbeder-contact-panel-open');
      window.requestAnimationFrame(() => {
        root.classList.add('is-open');
        closeButton.focus({ preventScroll: true });
      });
    };

    const close = (restoreFocus = true) => {
      root.classList.remove('is-open');
      root.classList.remove('is-quote-open');
      document.body.classList.remove('senbeder-contact-panel-open');
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      hideTimer = window.setTimeout(() => {
        if (!isOpen()) panel.hidden = true;
      }, 190);
      if (restoreFocus) trigger.focus({ preventScroll: true });
    };

    const openQuote = () => {
      if (!quoteTrigger || !quotePanel) return;
      window.clearTimeout(hideTimer);
      if (isOpen()) close(false);
      quotePanel.hidden = false;
      quotePanel.setAttribute('aria-hidden', 'false');
      fitPanel(quotePanel);
      quoteTrigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('senbeder-contact-panel-open');
      window.requestAnimationFrame(() => {
        root.classList.add('is-open');
        root.classList.add('is-quote-open');
        quotePanel.classList.add('is-active');
        quoteCloseButton?.focus({ preventScroll: true });
      });
    };

    const closeQuote = (restoreFocus = true) => {
      if (!quoteTrigger || !quotePanel) return;
      quotePanel.classList.remove('is-active');
      root.classList.remove('is-quote-open');
      quotePanel.setAttribute('aria-hidden', 'true');
      quoteTrigger.setAttribute('aria-expanded', 'false');
      if (!isOpen()) document.body.classList.remove('senbeder-contact-panel-open');
      window.setTimeout(() => { if (!isQuoteOpen()) quotePanel.hidden = true; }, 190);
      if (restoreFocus) quoteTrigger.focus({ preventScroll: true });
    };

    trigger.addEventListener('click', () => (isOpen() ? close() : open()));
    closeButton.addEventListener('click', () => close());
    quoteTrigger?.addEventListener('click', () => (isQuoteOpen() ? closeQuote() : openQuote()));
    quoteCloseButton?.addEventListener('click', () => closeQuote());

    document.addEventListener('pointerdown', (event) => {
      if ((isOpen() || isQuoteOpen()) && !root.contains(event.target)) { close(false); closeQuote(false); }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isQuoteOpen()) closeQuote();
      else if (event.key === 'Escape' && isOpen()) close();
    });

    window.addEventListener('pageshow', () => {
      if (isOpen()) close(false);
      positionAtTopOfStack(root);
    });

    window.addEventListener('resize', () => {
      positionAtTopOfStack(root);
      if (isOpen()) fitPanel(panel);
      if (isQuoteOpen()) fitPanel(quotePanel);
    }, { passive: true });
    positionAtTopOfStack(root);
    window.setTimeout(() => positionAtTopOfStack(root), 500);
    window.setTimeout(() => positionAtTopOfStack(root), 2000);

    const observer = new MutationObserver(() => positionAtTopOfStack(root));
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  const initAll = () => roots().forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
